import VueRouter from 'vue-router';

import routes from './routes';


// configure router

const router = new VueRouter({

  routes,

  linkExactActiveClass: 'active',

  scrollBehavior: (to) => {

    if (to.hash) {

      return { selector: to.hash };

    } else {

      return { x: 0, y: 0 };

    }

  }

});


router.beforeEach((to, from, next) => {

  if (to.name === 'Logout') {

    localStorage.clear(); // Clears access_token when clicking logout

  }


  if (to.name !== 'login' && localStorage.getItem('access_token') === null) {

    next({ name: 'login' });

  } else {

    next();

  }

});


export default router;


window.addEventListener('beforeunload', () => {

  localStorage.clear();  // auto-clear token on tab or browser close

});

